/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
import React from 'react';

import {
  TableContainer,
  Table,
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  Paper,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    marginTop: '30px',
    marginBottom: '30px',
  },
  table: {
    width: '100%',
    minWidth: 650,
    '& .MuiTableCell-root': {
      borderLeft: '1px solid rgba(224, 224, 224, 1)',
    },
  },
  empty: {
    backgroundColor: '#f3f2f2',
  },
  caption: {
    paddingLeft: '15px',
  },
});

const CourseInformations = () => {
  const classes = useStyles();
  return (
    <TableContainer component={Paper} className={classes.root}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="center" className={classes.empty}> </TableCell>
            <TableCell align="center">Débutant</TableCell>
            <TableCell align="center">Elémentaire</TableCell>
            <TableCell align="center">Pré-intermédiaire</TableCell>
            <TableCell align="center" colSpan={2}>Intermédiaire</TableCell>
            <TableCell align="center">Avancé</TableCell>
            <TableCell align="center">Autonome</TableCell>
            <TableCell align="center">Maîtrise</TableCell>
            <TableCell align="center">Bilingue</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell align="center" variant="head">EW</TableCell>
            <TableCell align="center">0-2</TableCell>
            <TableCell align="center">3</TableCell>
            <TableCell align="center">4</TableCell>
            <TableCell align="center">5</TableCell>
            <TableCell align="center">6</TableCell>
            <TableCell align="center">7</TableCell>
            <TableCell align="center">8</TableCell>
            <TableCell align="center">9</TableCell>
            <TableCell align="center">10</TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center" variant="head" rowSpan={2}>Conseil de l Europe(*)</TableCell>
            <TableCell align="center" className={classes.empty}> </TableCell>
            <TableCell align="center">A1</TableCell>
            <TableCell align="center">A2</TableCell>
            <TableCell align="center" colSpan={2}>B1</TableCell>
            <TableCell align="center">B2</TableCell>
            <TableCell align="center">C1</TableCell>
            <TableCell align="center">C2</TableCell>
            <TableCell align="center" className={classes.empty}> </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Débutant</TableCell>
            <TableCell align="center" colSpan={2}>Utilisateur élementaire</TableCell>
            <TableCell align="center" colSpan={3}>Utilisateur Indépendant</TableCell>
            <TableCell align="center" colSpan={2}>Utilisateur expérimenté</TableCell>
            <TableCell align="center" className={classes.empty}> </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Typography className={classes.caption} variant="caption">(*) Cadre européen commun de référence pour les langues (CECR)</Typography>
    </TableContainer>
  );
};

export default CourseInformations;
